import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/app'
    },
    {
      name: 'InitialLoading',
      path: '/loading',
      component: () => import('@/views/Loading')
    },
    {
      name: 'InitialKey',
      path: '/key',
      component: () => import('@/views/Key'),
      beforeEnter: (to, from, next) => {
        if (!store.getters['device/mac']) {
          next({ name: 'InitialLoading' })
        } else {
          next()
        }
      }
    },
    {
      name: 'App',
      path: '/app',
      component: () => import('@/views/AppContainer'),
      beforeEnter: (to, from, next) => {
        if (!store.getters['device/isIdentified']) {
          next({ name: 'InitialLoading' })
        } else {
          next()
        }
      }
    }
  ]
})

export default router
